import { render, staticRenderFns } from "./NetworkProblem.vue?vue&type=template&id=5b81dc94&scoped=true&"
import script from "./NetworkProblem.vue?vue&type=script&lang=ts&"
export * from "./NetworkProblem.vue?vue&type=script&lang=ts&"
import style0 from "./NetworkProblem.vue?vue&type=style&index=0&id=5b81dc94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b81dc94",
  null
  
)

export default component.exports